export const MODAL_TYPE_SHARE_COMMENT = 'share-comment';
